import { es } from "../../../../date-fns/locale/es.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    es
  }
};